import React, { useState } from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
import TopNav from "./topnav";
import Nav from "./nav";

import Phone from "../../assets/icons/phone.svg";
import Hero from "../hero/hero";
import SearchForm from "../search-form/search-form";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import ObfuscatedLink from "../obfuscated-link";
import CartModal from "../cart-modal";
import { readCart, writeCart } from "../../utils/cart";
const Header = ({ title, description, showBanner: showHero = false, heroImage: bgImage, productAdded }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const [cart, setCart] = useState([]);
  const { logo } = useStaticQuery(query);
  const [utmParams, setUTMParams] = useState({});

  React.useEffect(() => {
    if (productAdded && openCart === false) {
      toggleModal();
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      productAdded = null;
    }
  }, undefined);

  React.useEffect(() => {
    // Récupérer depuis dataLayer
    if (typeof window !== 'undefined') {
      const storedUTM = window.dataLayer.find(item => item.event === "utm_params_received");
      if (storedUTM) {
        setUTMParams(storedUTM.utm_params);
      }
    }
  }, [setUTMParams]);

  // Bloque le scroll de la page derrière la modale devis
  React.useEffect(() => {
    if (typeof document === 'undefined') return;
    document.body.classList.toggle('cart-open', openCart);
    return () => document.body.classList.remove('cart-open');
  }, [openCart]);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  }

  const toggleModal = () => {
    if (openCart === true) {
      setOpenCart(false);
    } else {
      const cartContent = readCart();
      if (cartContent.length === 0) return;
      setCart(cartContent);
      setOpenCart(true);
    }
  };

  const cartContentCount = readCart().reduce(
    (acc, item) => (acc += +item.quantity),
    0
  );

  const removeItem = (index) => (e) => {
    e.preventDefault();
    if (index < 0 || index >= cart.length) return;
    const newCart = cart.filter((_, i) => i !== index);
    writeCart(newCart);
    if (newCart.length === 0) setOpenCart(false);
    setCart(newCart);
  };

  const purgeCart = () => {
    writeCart([]);
    setOpenCart(false);
    setCart([]);
  };

  return (
    <>
      <div className="top-0 sticky w-full z-50 bg-white shadow" style={{ position: 'sticky' }}>
        <TopNav />

        <header className="container relative px-4 py-2 lg:py-4" role="banner">
          <div className="flex justify-between items-center lg:items-end">
            <a href="#" onClick={toggleMenu} className="block lg:hidden">
              <svg fill="#123b84" viewBox="0 0 100 80" width="40" height="40">
                <rect width="100" height="15"></rect>
                <rect y="30" width="100" height="15"></rect>
                <rect y="60" width="100" height="15"></rect>
              </svg></a>
            <Link
              to="/"
              title="L'atelier du tote bag - Impression de tote bags personnalisés"
              rel="home"
              className="block"
            >
              <GatsbyImage
                image={getImage(logo)}
                alt="Logo de l'atelier du tote bag"
              // className="w-32 md:w-40 lg:w-auto"
              // imgStyle={{ maxWidth: '100%', height: 'auto' }}
              />
            </Link>

            <div className="md:flex-grow md:ml-4">
              <div className="flex items-center justify-between lg:mb-5">
                <SearchForm />
                <div className="hidden lg:block">
                  <ObfuscatedLink to="tel:+33 9 72 63 01 32">
                    <Phone className="inline-block relative -top-1" />{" "}
                    <span className="text-1.5xl font-semibold hover:text-blue">
                      +33 9 72 63 01 32
                    </span>
                  </ObfuscatedLink>
                </div>
                {cartContentCount > 0 && (
                  <div
                    onClick={toggleModal}
                    className="flex items-center text-blue cursor-pointer"
                  >
                    <span className="hidden lg:block uppercase text-sm mr-3">Votre devis</span>
                    <div className="relative">
                      <span className="cart-icon-handle" />
                      <div className=" flex justify-center items-center w-9 h-8 border-2 border-blue font-semibold text-sm">
                        {cartContentCount}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Nav showMenu={showMenu} closeMenu={() => setShowMenu(false)} />
            </div>
          </div>
        </header>
      </div>

      <div>
        {(showHero || bgImage) && <Hero description={description} title={title} bgImage={bgImage} />}

        <CartModal
          open={openCart}
          cart={cart}
          onClose={() => setOpenCart(false)}
          onRemove={removeItem}
          onSubmitted={purgeCart}
          utmParams={utmParams}
        />
      </div>

      <div className="hidden md:grid-cols-1 md:grid-cols-2 md:grid-cols-3 md:grid-cols-4 md:grid-cols-5 md:grid-cols-6 md:grid-cols-7 md:grid-cols-8"></div>
    </>
  );
};

const query = graphql`
  query {
    logo: file(
      relativePath: { eq: "Logo-latelierdutotebag.png" }
      sourceInstanceName: { eq: "logos" }
    ) {
      childImageSharp {
        gatsbyImageData(
          height: 100
          backgroundColor: "white",
          quality: 100,
          layout: CONSTRAINED
        ) 
      }
    }
    image1: file( relativePath: { eq: "devien-en-24h-latelier-du-tote-bag-1.png" }) {
      childImageSharp {
        gatsbyImageData(
          width: 80
          height: 80
        ) 
      }
    }
    image2: file(
      relativePath: {
        eq: "livraison-express-latelier-du-tote-bag.png"
      }
      sourceInstanceName: { eq: "uploads" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 80, height: 80) 
      }
    }
  }
`;

export default Header;
